import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import customTheme from 'commonComponents/whiteTheme';

const WhiteSpinner = ({ ...props }) => (
  <MuiThemeProvider
    theme={
      createMuiTheme({
        ...customTheme
      })
    }
  >
    <CircularProgress
      { ...props }
    />
  </MuiThemeProvider>
);

export default WhiteSpinner;
